import { getNumberFormat } from "../../utils/enums";

export const LimitAllocationCommColumns = () => {
  return [
    { field: "id", headerName: "ID", width: 90, hide: true },
    {
      field: "amount",
      headerName: "Tutar",
      sortable: false,
      width: 200,
      align: "right",
      headerAlign: "center",
      valueGetter: (params) => {
        return getNumberFormat(params.value);
      },
    },
  ];
};
